// Angular dependencies
import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  HostListener
} from '@angular/core';

// Store
import { Store } from '@ngrx/store';
import {
  AppState,
  UpdateCreepAction,
  RemoveCreepAction
} from '../../store.module';

import {
  CREEP_OPERATOR,
  CREEP_COMMANDER,
  CREEP_EXECUTOR
} from '../../creep/creep.enum';
import { Creep } from '../../creep/creep';
import { Skill } from '../../creep-skill';

@Component({
  selector: 'app-creep',
  templateUrl: './creep.component.html',
  styleUrls: ['./creep.component.scss']
})
export class CreepComponent {
  @Input() creep: Creep;
  @ViewChild('inputCreepName') inputCreepName: ElementRef;

  public confirmRemove = false;
  public isEditName = false;

  constructor(
    private _elementRef: ElementRef,
    private _store: Store<AppState>
  ) {
  }

  get skills(): Skill[] {
    return this.creep.skills.toArray().filter(({ level }) => {
      return level;
    }) as Skill[];
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target) {
    let outside = true;

    do {
      if (target === this._elementRef.nativeElement) {
        outside = false;
      }

      target = target.parentNode;
    } while (target);

    if (outside) {
      this.confirmRemove = false;
    }
  }

  startEditName() {
    this.isEditName = true;

    setTimeout(() => {
      this.inputCreepName.nativeElement.focus();
    });
  }

  stopEditName() {
    this.isEditName = false;
  }

  isOperator(): boolean {
    return this.creep.type === CREEP_OPERATOR;
  }

  isCommander(): boolean {
    return this.creep.type === CREEP_COMMANDER;
  }

  idExecutor(): boolean {
    return this.creep.type === CREEP_EXECUTOR;
  }

  onChange() {
    this._store.dispatch(new UpdateCreepAction([this.creep, this.creep]));
  }

  onRemove() {
    this._store.dispatch(new RemoveCreepAction(this.creep));
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/creep.component/creep.component.ts